/**
 * @see https://umijs.org/docs/max/access#access
 * */

import { map } from 'lodash-es';
import type { IUserInfo } from '@/services/user/getUserInfo';

// 权限标识转换
function permIdTransform(arr: string[]) {
  return map(arr, (item) => item.replace(/:/g, '_'));
}

// 默认权限配置
const DEFAULT_PERMISSIONS = {
  system: false,
  system_user_list: false,
  system_user_query: false,
  system_user_add: false,
  system_user_edit: false,
  system_user_remove: false,
  system_user_resetPwd: false,
  system_user_assignRole: false,
  system_role_list: false,
  system_role_query: false,
  system_role_add: false,
  system_role_edit: false,
  system_role_remove: false,
  system_role_dataScope: false,
  system_menu_list: false,
  system_menu_query: false,
  system_menu_add: false,
  system_menu_edit: false,
  system_menu_remove: false,
  system_dept_list: false,
  system_dept_query: false,
  system_dept_add: false,
  system_dept_edit: false,
  system_dept_remove: false,
  log: false,
  system_operlog_list: false,
  system_logininfor_list: false,
  //BD管理
  bd: false,
  //BD管理-人员管理
  bd_user_list: false,
  bd_user_add: false,
  bd_user_edit: false,
  bd_user_remove: false,
  bd_user_return_commission: false,
  bd_user_socialMedia_edit: false,
  //BD管理-权限管理(邀请链路)
  bd_permissions: false,
  // 合约合伙人
  futures: false,
  //合约合伙人-返佣配置
  coAgent_role_page: false,
  coAgent_role_add: false,
  coAgent_role_update: false,
  coAgent_role_delete: false,
  coAgent_role_base_set: false,
  //合约合伙人-团队管理
  coAgent_user_page: false,
  coAgent_user_edit: false,
  coAgent_user_remove: false,
  //合约合伙人-团队交易量
  futures_tradingVolume_list: false,
  //合约合伙人-团队佣金
  futures_commission_list: false,
  //合约合伙人-我的佣金
  futures_self_commission_list: false,
  //合约合伙人-下级持仓
  coPosition_list: false,
  //合约合伙人-团队佣金汇总
  futures_commissionSummary_page: false,
  //合约合伙人-团队佣金明细
  futures_commissionDetail_page: false,
  //现货合伙人
  spot: false,
  //现货合伙人-返佣配置
  agent_role_page_list: false,
  agent_role_add: false,
  agent_role_remove: false,
  //现货合伙人-团队管理
  agent_user_list: false,
  agent_user_add: false,
  agent_user_edit: false,
  agent_user_remove: false,
  //现货合伙人-团队交易量
  spot_teamTradingVolume_list: false,
  //现货合伙人-团队佣金
  spot_teamCommission_list: false,
  //现货合伙人-我的佣金
  spot_myCommission_list: false,
  //资金记录
  fundRecords: false,
  //提现记录
  withdraw_page: false,
  //充值记录
  transaction_page: false,
  //划转记录
  transfer_page: false,
  //合约看板
  dashboard_futures: false,
  //现货看板
  dashboard_spot: false,
  //数据总览
  partner_dashboard: false,
  //团队管理
  teamManagement: false,
  teamManagement_setUserRemark: false,
  teamManagement_promotion: false,
  teamManagement_edit: false,
  teamManagement_query: false,
  teamManagement_cancel: false,
  //链路管理
  invitationLink: false,
  invitationLink_status_set: false,
  invitationLink_remark_set: false,
  invitationLink_del: false,
  invitationLink_add: false,
  invitationLink_page: false,
  //团队交易量
  volumeDaily_page: false,
  //活动数据
  dataStat_query: false,
} as Record<string, boolean>;

export default function access(initialState: { userInfo?: IUserInfo } | undefined) {
  const { userInfo } = initialState || {};
  const isOperation = userInfo?.roles?.includes('operations') || userInfo?.roles?.includes('admin');

  // 如果是超级管理员，直接返回所有权限为true
  if (userInfo?.permissions?.includes('*:*:*')) {
    const permissions = Object.fromEntries(Object.keys(DEFAULT_PERMISSIONS).map((key) => [key, true]));
    // 如果是运营或管理员，partner_dashboard必须为false
    if (isOperation) {
      permissions.partner_dashboard = false;
    }
    return permissions;
  }

  // 普通用户权限处理
  if (userInfo?.permissions?.length) {
    const transformArr = permIdTransform(userInfo.permissions);
    const permissions = {
      ...DEFAULT_PERMISSIONS,
      ...Object.fromEntries(transformArr.map((perm) => [perm, true])),
    };
    // 如果是运营或管理员，partner_dashboard必须为false
    if (isOperation) {
      permissions.partner_dashboard = false;
    }
    return permissions;
  }

  // 无权限用户
  return DEFAULT_PERMISSIONS;
}
